import "./App.css";
import {
  BrowserRouter as Router, Route
} from "react-router-dom";

import MainPage from "./components/MainPage";
import PasswordReset from './components/PasswordReset';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill()

function App() {
  return (
    <Router>
      <Route exact path='/'><MainPage /></Route>
      <Route exact path='/:lang'><MainPage /></Route>
      <Route path='/token/:tkn'><PasswordReset /></Route>
    </Router>
  );
}

export default App;
